/**
 * Global auth interceptor - signs user out on invalid/expired JWT (401/403).
 * Import this file once in App.js as a side-effect.
 */
import axios from "axios";
import cookie from "react-cookies";

// Flag to prevent multiple logout redirects
let isLoggingOut = false;

function handleAuthFailure() {
  // Only sign out if the user is actually logged in
  if (!cookie.load("session-id-qt")) return;
  if (isLoggingOut) return;
  isLoggingOut = true;

  // Clear auth cookies (mirrors the logout in /auth/logout)
  cookie.remove("session-id-qt", { path: "/" });
  cookie.remove("ctName", { path: "/" });
  cookie.remove("localsessionid", { path: "/" });
  cookie.remove("promocode", { path: "/" });

  // Clear localStorage
  localStorage.clear();

  // Redirect to login
  window.location.href = "/";
}

// Axios global interceptor - catches 401/403 on all axios calls
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);

// Patch global fetch - catches 401/403 on all fetch() calls
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401 || response.status === 403) {
    handleAuthFailure();
  }
  return response;
};
